import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import DialogDropinAdyen from '../dialogs/dialog-dropin-adyen';
import mensalidadeService from '../../services/mensalidades/mensalidadeService';
import DialogSuccessPagamentoCartao from '../dialogs/dialog-pagamento-cartao';

export default function ParcelarMensalidade({ inscricao, associado, valorTotal }) {
    const [isAbrirCardPagamentoCartao, setAbrirCardPagamentoCartao] = useState(false);
    const [isPagamentoSuccess, setPagamentoSuccess] = useState(false);
    const [_isMetodoPagamento, setMetodoPagamento] = useState(null);
    const [isFaturas, setFaturas] = useState(null);
    const [isMensalidadePaga, setMensalidadePaga] = useState(true);

    const handleButtonClick = () => {
        setAbrirCardPagamentoCartao(true);
    };

    const { SubGrupo } = associado;
    const valorNumerico = Number(valorTotal?.replace(/[^\d,]/g, '')?.replace(',', '.'));

    useEffect(() => {
        (async () => {
            try {
                const mensalidades = await mensalidadeService.buscaMensalidadesPorInscricao(inscricao);

                setMensalidadePaga(mensalidades[0].Pagamento !== null);

                setFaturas(
                    mensalidades?.map(mensalidade => ({
                        Valor: valorNumerico,
                        Referencia: mensalidade.Referencia
                    }))
                );
            } catch (error) {
                console.error('Erro ao buscar mensalidades:', error);
            }
        })();
    }, [isAbrirCardPagamentoCartao]);

    const isFaturaValorValido = isFaturas && isFaturas.length > 0 && typeof isFaturas[0].Valor === 'number' && !isNaN(isFaturas[0].Valor);

    return (
        <div>
            {!isMensalidadePaga && (
                <Button
                    label="Parcelar Mensalidade"
                    className="p-button-warning"
                    onClick={handleButtonClick}
                />
            )}

            {isAbrirCardPagamentoCartao && isFaturaValorValido && (
                <DialogDropinAdyen
                    open={isAbrirCardPagamentoCartao}
                    setOpen={setAbrirCardPagamentoCartao}
                    header="Cartão de Crédito"
                    setMetodoPagamento={setMetodoPagamento}
                    faturas={isFaturas}
                    inscricao={inscricao}
                    setPagamentoSuccess={setPagamentoSuccess}
                    subGrupo={SubGrupo}
                />
            )}
            <DialogSuccessPagamentoCartao openDialog={isPagamentoSuccess} />
        </div>
    );
}
